import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import FeatureHero from './components/FeatureHero';
import InventoryManagement from './components/InventoryManagement';
import ReportingCapabilities from './components/ReportingCapabilities';
import UserPermissions from './components/UserPermissions';
import AdditionalFeatures from './components/AdditionalFeatures';
// MultiStoreDashboard removed until feature is available
import CTASection from './components/CTASection';
import ScrollToTop from '../../components/ScrollToTop';

const Features = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Features - Cultaz | Comprehensive Retail Management Solutions for Nigerian Businesses</title>
        <meta
          name="description"
          content="Explore Cultaz's powerful features: real-time inventory management, advanced reporting, user permissions, POS system, barcode scanning, and multi-store support. Built for Nigerian retailers."
        />
        <meta
          name="keywords"
          content="retail management features, inventory tracking, POS system features, business analytics, retail software features, inventory management system, point of sale features, Nigeria retail software"
        />
        <meta name="author" content="Cultaz" />
        <meta property="og:title" content="Features - Cultaz | Comprehensive Retail Management Solutions" />
        <meta property="og:description" content="Powerful features for retailers: real-time inventory tracking, advanced analytics, POS system, user permissions, and multi-store support. Built for Nigerian businesses." />
        <meta property="og:image" content="https://cultaz.com/banners/1.png" />
        <meta property="og:url" content="https://cultaz.com/features" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cultaz" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Features - Cultaz | Retail Management Solutions" />
        <meta name="twitter:description" content="Powerful features for retailers: inventory, POS, reporting, and more. Built for Nigerian businesses." />
        <meta name="twitter:image" content="https://cultaz.com/banners/1.png" />
        <link rel="canonical" href="https://cultaz.com/features" />
      </Helmet>

      <ScrollToTop />
      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <FeatureHero />
          <InventoryManagement />
          <ReportingCapabilities />
          <UserPermissions />
          <AdditionalFeatures />
          <CTASection />
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default Features;